import React, { useEffect } from "react";
import CarouselComponent from "../../Components/Carousel/Carousel";
import Aos from "aos";

function Images(props) {
  useEffect(() => {
    Aos.init({ duration: 1000 });
  });
  return (
    <div data-aos="slide-up" className="h-[100vh] p-20">
      <CarouselComponent />
    </div>
  );
}

export default Images;
